export default Object.freeze({
	quantity: 1,
	description: '',
	measurement_unit: '',
	link: '',
	price: '',
	available: true,
	supplier_id: '',
})
